import {z} from 'zod';

export const FinancialProductMoneySchema = z.object({
  amount: z.string(),
  currency: z.string(),
});
export type FinancialProductMoney = z.infer<typeof FinancialProductMoneySchema>;
